import Link from 'next/link'
import { Join } from '../../lib/utils'

interface ButtonLGProps {
  href: string
  children: React.ReactNode
  variant?: 'primary' | 'secondary' | 'none'
  classNames?: string
  ariaLabel?: string
  onClick?: () => void
}

export function ButtonLG({
  href,
  children,
  variant = 'primary',
  classNames,
  ariaLabel,
  onClick,
}: ButtonLGProps) {
  const baseClasses =
    'group rounded-full px-6 py-3 transition-colors duration-200 flex gap-2 items-center ease-out'

  const variantClasses: Record<string, string> = {
    primary:
      'bg-primary-600 text-white hover:bg-primary-700 dark:bg-blue-600 dark:hover:bg-blue-500',
    secondary:
      'border border-slate-300 text-slate-700 hover:bg-slate-50 dark:border-slate-700 dark:text-slate-200 dark:hover:bg-slate-800',
    none: '',
  }
  const variantClass = variantClasses[variant] ?? ''

  const classes = Join(baseClasses, variantClass, classNames)

  // Hash anchors are a no-op when the hash is already in the URL, so scroll
  // imperatively on every click to always reposition to the target element.
  const handleClick = href.startsWith('#')
    ? (e: React.MouseEvent) => {
        const el = document.getElementById(href.slice(1))
        if (el) {
          e.preventDefault()
          el.scrollIntoView({ behavior: 'smooth' })
        }
        onClick?.()
      }
    : onClick

  return (
    <Link
      href={href}
      className={classes}
      aria-label={ariaLabel}
      onClick={handleClick}
    >
      {children}
    </Link>
  )
}
